/**
 * "Fortsätt din omgång (fråga 3 av 10)": offered on `/practice` and Home when a stored practice set
 * is unfinished (P0-1). The set lives in `sessionStorage` per tab and, with a 7-day limit, in
 * `localStorage`, so a new tab or the next day finds it here instead of a silent redirect.
 */
import { useState } from "react";
import { Link } from "react-router";
import { Button, Card } from "@client/components/ui";
import { useT } from "@client/i18n";
import { PRIMARY_LINK } from "./today/linkClass";
import { clearSession, resumableStoredSession } from "./session";

export function ResumeCard() {
  const t = useT();
  // Read once: the set is written by the session page, which is not mounted here.
  const [stored, setStored] = useState(() => resumableStoredSession());
  if (!stored) return null;
  const answered = stored.questions.filter((q) => stored.results[q.id]?.terminal).length;
  const position = Math.min(stored.index + 1, stored.questions.length);
  return (
    <Card title={t("practice.resume.title")} className="mb-6">
      <p className="mb-3 text-sm text-ink-700 dark:text-ink-200">
        {t("practice.resume.body", {
          position: String(position),
          total: String(stored.questions.length),
          answered: String(answered),
        })}
      </p>
      <div className="flex flex-wrap items-center gap-3">
        <Link to="/practice/session" className={PRIMARY_LINK}>
          {t("practice.resume.continue", {
            position: String(position),
            total: String(stored.questions.length),
          })}
        </Link>
        <Button
          variant="secondary"
          onClick={() => {
            clearSession();
            setStored(null);
          }}
        >
          {t("practice.resume.discard")}
        </Button>
      </div>
    </Card>
  );
}
